export default __webpack_public_path__ + "static/media/landingImage.0894d415.svg";